
export class Controller {

    /** @ngInject */
    constructor($state, $timeout, Alert,  SharedAccountsService) {
        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
        this.$state = $state;
        this.$timeout= $timeout;
    }

    $onInit() {
		this.fileType=null;
        this.importResult=null;
        this.fileToUpload = { value: null };
        this.isUploading=false;
        //this.importFileTypes=['GENERIC','MOZILLA','CLASSIC_BROWSER'];//when we start suppoting all types just delete this line
    }
    
    uploadCSV(){
		 if(!this.fileToUpload.value) {
                return;
            }
            this.isUploading=true;
            const formData = new FormData();
        	formData.append('file', this.fileToUpload.value);
            this.SharedAccountsService
            .importCompanyServiceAccountsFromCsv(
                {
                    companyId: this.companyId,
                    fileType: this.fileType
                },
                formData
            )
            .$promise
            .then(results => {
				console.log(results);
				this.$state.go('.import-completed', {importResult: results});
            }).catch(error =>{
					console.log(error);
					//this.Alert('danger',error.message);
			})
            .finally(() => {this.isUploading = false;this.fileToUpload = { value: null };})
	}
	
	 fnc() {
            this.$timeout(() =>{ document.getElementById("uploadInput").click(); });                    
     };
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/import-csv/import-csv.controller.js